export enum UserRole {
  User = "user",
  Admin = "admin",
}

export enum Gender {
  Male = "male",
  Female = "female",
}
